/* global window */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { css, cx } from 'emotion'
import PageNotFound from 'screens/PageNotFound'
import ScrollToTop from 'components/ScrollToTop'
import { Divider, Container } from 'semantic-ui-react'
import 'themes/enlarged.css'

import FlyerGrid from './screens/FlyerGrid'
import FlyerDetail from './screens/FlyerDetail'
import Brandbar from '../../shared/components/Brandbar'
import FlyersFooter from './components/FlyerFooter'
import useProfile from '../../shared/hooks/useProfile'

const Flyers = ({ match }) => {
  const profile = useProfile()
  const isMin = window.location.search.includes('min')
  const isContainerized = window.location.search.includes('container')

  return (
    <ScrollToTop>
      <div
        className={cx(styles.container, {
          [styles.platinumBackground]: isMin,
          [styles.innerPad]: isMin && isContainerized
        })}
      >
        {!isMin && <Brandbar />}
        <div
          className={cx(styles.body, {
            'ui container': !isMin || isContainerized
          })}
        >
          <Switch>
            <Route
              path={`${match.url}/all/:resource(schools|districts)/:resourceId`}
              render={props => <FlyerGrid {...props} profile={profile} />}
            />
            <Route
              path={`${match.url}/:flyerId/:resource(schools|districts)/:resourceId/:extra`}
              component={PageNotFound}
            />
            <Route
              path={`${match.url}/:flyerId/:resource(schools|districts)/:resourceId`}
              render={props => <FlyerDetail {...props} />}
            />
            <Route component={PageNotFound} />
          </Switch>
        </div>
        {!isMin && (
          <React.Fragment>
            <Divider className={styles.divider} />
            <Container>
              <FlyersFooter />
            </Container>
          </React.Fragment>
        )}
      </div>
    </ScrollToTop>
  )
}

const styles = {
  container: css`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  `,
  body: css`
    flex: 1;
    display: flex !important;
    flex-direction: column;
  `,
  platinumBackground: css`
    background: #f5f5f5;
  `,
  innerPad: css`
    padding-top: 4rem;
  `,
  divider: css`
    margin: 0;
    margin-top: 1rem;
  `
}

export default Flyers



// WEBPACK FOOTER //
// ./src/screens/Flyers/index.js